import { Divider, Loader } from '@/shared'
import { type IServiceRulesWrapper } from '@App/types/servicesTypes'

import { RulesOptions } from './RulesOptions/RulesOptions'
import style from './ServiceRules.module.scss'

interface IProps {
    isFetching: boolean
    serviceRules: IServiceRulesWrapper | null
    onChangeRules: (dto: IServiceRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const ServiceRules = (props: IProps) => {
    const { isFetching, serviceRules, onChangeRules } = props
    return (
        <>
            {serviceRules && (
                <div className={style.container}>
                    <div className={style.divider}>
                        <Divider />
                    </div>
                    {!serviceRules.sections[0] && (
                        <div className={style.empty}>
                            <div className={style.title}>
                                <span>Правило отсутствует</span>
                            </div>
                        </div>
                    )}
                    <RulesOptions isFetching={isFetching} serviceRules={serviceRules} onChangeRules={onChangeRules} />
                </div>
            )}
            {!serviceRules && <Loader />}
        </>
    )
}
